//#region constants
// var mainUrl = '//api.architektura.bytom.pl';
var mainUrl = '//api.architektura.bytom.pl';
const devUrl = 'https://localhost:44374'
const isDev = false;
if (isDev) {
    mainUrl = devUrl;
}

const urls = {
    bibliography: mainUrl + '/bibliography',
    people: mainUrl + '/people',
    buildings: mainUrl + '/buildings',
    search: mainUrl + '/search',
    login: mainUrl + '/authenticate',
    aboutProject: mainUrl + '/about-project',
    education: mainUrl + '/education',
    bibliographyAdmin: mainUrl + '/bibliography-admin',
    peopleAdmin: mainUrl + '/people-admin',
    buildingsAdmin: mainUrl + '/buildings-admin',
    aboutProjectAdmin: mainUrl + '/about-project-admin',
    educationAdmin: mainUrl + '/education-admin',
    images: mainUrl + '/images',
    imagesAdmin: mainUrl + '/images-admin'
}


async function getData(url) {
    let response = await fetch(url);
    if (!response.ok) {
        response = await fetch(url);
    }
    return await response.json();
}

function getHeader() {
    return {
        "Content-type": "application/json",
        "accept": "application/json",
        //DODAĆ token z localstorage.token gdzie potrzebne, przy logowaniu nie jest potrzebny
        Authorization: 'Bearer ' + localStorage.token
    }
}

async function postData(url, data) {
    let metaData = {
        headers: getHeader(),
        method: 'post',
        body: JSON.stringify(data)
    }
    try {
        let response = await fetch(url, metaData);
        if (!response.ok) {
            return { status: response.status, ok: response.ok };
        }
        return { data: await response.json(), ok: response.ok };
    } catch {
        return { ok: false, status: 1000 }
    }
}


async function putData(url, data) {
    let metaData = {
        headers: getHeader(),
        method: 'put',
        body: JSON.stringify(data)
    }
    try {
        let response = await fetch(url, metaData);
        if (!response.ok) {
            return { status: response.status, ok: response.ok };
        }
        return { data: await response.json(), ok: response.ok };
    } catch {
        return { ok: false, status: 1000 }
    }
}
//Możliwa metoda do przedefiniowania
async function deleteData(url) {
    let metaData = {
        headers: getHeader(),
        method: 'delete',
    }
    try {
        let response = await fetch(url, metaData);
        console.log(response)
        if (!response.ok) {
            return { status: response.status, ok: response.ok };
        }
        return { data: await response.json(), ok: response.ok };
    } catch {
        return { ok: false, status: 1000 }
    }
}
//#endregion

//#region api
const api = {
    getBibliography: async function () {
        return await getData(urls.bibliography);
    },
    getBibliographyItem: async function (id) {
        return await getData(urls.bibliography + '/' + id);
    },
    getPeople: async function () {
        return await getData(urls.people);
    },
    getPerson: async function (slug) {
        return await getData(urls.people + '/' + slug);
    },
    getPersonById: async function (id) {
        return await getData(urls.people + '/id/' + id);
    },
    getPersonImagesById: async function (id) {
        return await getData(urls.images + '/person/' + id);
    },
    getBuildings: async function () {
        return await getData(urls.buildings);
    },
    getBuilding: async function (slug) {
        return await getData(urls.buildings + '/' + slug);
    },
    getBuildingDetails: async function (slug) {
        return await getData(urls.buildings + '/details/' + slug);
    },
    getBuildingDetailsById: async function (id) {
        return await getData(urls.buildings + '/detailsAll/id/' + id);
    },
    getBuildingImagesById: async function (id) {
        return await getData(urls.images + '/building/' + id);
    },
    search: async function (query) {
        return await getData(urls.search + '?query=' + query);
    },
    login: async function (data) {
        return await postData(urls.login + '/login', data);
    },
    register: async function (data) {
        return await postData(urls.login + '/register', data);
    },
    createBibliography: async function (data) {
        return await postData(urls.bibliographyAdmin, data);
    },
    updateBibliography: async function (data) {
        return await putData(urls.bibliographyAdmin, data);
    },
    deleteBibliography: async function (id) {
        return await deleteData(urls.bibliographyAdmin+ '/' + id);
    },
    createPerson: async function (data) {
        return await postData(urls.peopleAdmin, data);
    },
    updatePerson: async function (data) {
        return await putData(urls.peopleAdmin, data);
    },
    updatePersonImages: async function (data) {
        return await putData(urls.imagesAdmin, data);
    },
    deletePerson: async function (id) {
        return await deleteData(urls.peopleAdmin + '/' + id);
    },
    createBuilding: async function (data) {
        return await postData(urls.buildingsAdmin, data);
    },
    updateBuilding: async function (data) {
        return await putData(urls.buildingsAdmin, data);
    },
    updateBuildingImages: async function (data) {
        return await putData(urls.imagesAdmin, data);
    },
    deleteBuilding: async function (id) {
        return await deleteData(urls.buildingsAdmin + '/' + id);
    },
    getAboutProject: async function () {
        return await getData(urls.aboutProject);
    },
    updateAboutProject: async function (data) {
        return await putData(urls.aboutProjectAdmin, data);
    },
    getEducationMaterials: async function () {
        return await getData(urls.education);
    },
    getEducationMaterialById: async function (id) {
        return await getData(urls.education + '/' + id);
    },
    createEducationMaterial: async function (data) {
        return await postData(urls.educationAdmin, data);
    },
    updateEducationMaterial: async function (data) {
        return await putData(urls.educationAdmin, data);
    },
    deleteEducationMaterial: async function (id) {
        return await deleteData(urls.educationAdmin + '/' + id);
    },
    deleteOrphanImages: async function(){
        return await deleteData(urls.imagesAdmin);
    }
}

//#endregion

api.install = function (Vue) {
    Vue.prototype.$api = api;
}

export default api;